// components/RoleRoute.jsx
import { Navigate } from "react-router-dom";
import { dashboardPathForRole, getStoredUser } from "../utils/authSession";

export default function RoleRoute({ allowed = [], children, redirectTo }) {
  const user = getStoredUser();
  const role = user?.role || "";

  if (!allowed.length || allowed.includes(role)) return children;

  return <Navigate to={redirectTo || dashboardPathForRole(role)} replace />;
}
